import { useParams } from "react-router-dom"
import { useNavigateTo } from "../../../../../hooks/useNavigateTo.js"
import useFetch from "../../../../../hooks/useFetch.js"
import { getV2LiveDates, getV2LiveDetails } from "../../../../../../api/index.js"
import { useEffect, useMemo, useState } from "react"
import { getClosestDate } from "../../../../../helpers/dateHelper.js"
import LiveDTO from "../../../../../DTO/LiveDTO.js"
import CalendarNavigation from "../../../../../components/calendar/CalendarNavigation.js"
import { Box, CircularProgress, Typography } from "@mui/material"
import SportEventList from "./SportEventList.js"
import Filter from "./Filter.js"
import SearchFilterDTO from "../../../../../DTO/SearchFilterDTO.js"
import { startOfDay, endOfDay, format } from 'date-fns';

const LiveCollectCalendar = () => {

    const { idLive, date } = useParams();

    console.log("Date collect ", date)

    return <CalendarResolver/>

}

const CalendarResolver = () => {

    
  
    const navigateTo = useNavigateTo();
    const { idLive, date } = useParams();

    console.log("DRAW CALENDAR RESOLVER", date)
  
    const [liveCompetitionsDays, setLiveCompetitionsDays] = useState(null)
    const [liveDates, setLiveDates] = useState(null);

    const { data, isLoading, error, fetchData } = useFetch(getV2LiveDates, [idLive]);

    useEffect(() => {
        fetchData()
    }, [])

    useEffect(() => {
        if(!data || !data.eventsDates)
            return

        setLiveDates(data.eventsDates);

    }, [data])
  
    useEffect(() => {
      if(liveDates && liveDates.length){

        console.log("Ma date ", date)
        
        // Resolve the date if it is not provided
        const resolvedDate = date ?? getClosestDate(liveDates);

        console.log("Ma resolvedDate ", resolvedDate)
    
        // Update the URL with the resolved date if necessary
        if(resolvedDate!==date)
          navigateTo(`${resolvedDate}`, {}, ['competition']);
      }
  
    }, [idLive, date, liveDates, navigateTo])
  
    
    if (!liveDates && !liveCompetitionsDays) {
      return <CircularProgress />
    }
  
    return <CalendarDetail liveDates={liveDates}/>;
}

const CalendarDetail = ({liveDates}) => {

    console.log("DRAW calendar detail")

    const [sport, setSport] = useState("")

    const [sportEvents, setSportEvents] = useState('');

    const navigateTo = useNavigateTo();

    const [isDateLoading, setIsDateLoading] = useState(true)

    const { idLive, date } = useParams();

    const queryParameters = new URLSearchParams(window.location.search)
    const competition = queryParameters.get("competition")

    const searchFilter = useMemo(() => {
        const startOfDayDate = startOfDay(new Date(date));
        const endOfDayDate = endOfDay(new Date(date));

        return new SearchFilterDTO({global  : { _id : [idLive] }, sportevent : { beginDate : startOfDayDate, endDate : endOfDayDate } })
    }, [idLive, date])

    const { data, isLoading, error, fetchData } = useFetch(getV2LiveDetails, [searchFilter]);

    const [live, setLive] = useState(undefined)

    useEffect(() => {
        setSport("")
    }, [,date])

    useEffect(() => {
        if(!idLive || !date)
            return

        fetchData()
    }, [, searchFilter])
    //sport

    useEffect(() => {
        if(!data || !data[0])
            return

        const liveDTO = new LiveDTO(data[0]);
        setLive(liveDTO)
        //setSportEvents(liveDTO.sportEvents)
        setIsDateLoading(false)

        const filteredEvents = liveDTO.sportEvents.filter(event =>
            !sport || event.phase?.competitionDiscipline?.discipline?.sport?.label === sport
        );
        setSportEvents(filteredEvents);

    }, [data])

    useEffect(() => {
        if (!live) return;
    
        const filteredEvents = live.sportEvents.filter(event =>
            !sport || event.phase?.competitionDiscipline?.discipline?.sport?.label === sport
        );
        setSportEvents(filteredEvents);
    }, [live, sport]);

    const navigateToNewDate = (newDate) => {

        if(newDate === date)
                return

        const newPath = window.location.pathname.replace(/\/calendar\/[^/]+/, `/calendar/${newDate}`);

        setIsDateLoading(true)

        navigateTo(newPath);
    };

    const navigateToCustomArticle = () => {

        window.location.href = "https://www.lavoixdunord.fr/1440650/article/2024-03-14";

    };

    if(!live || isDateLoading)
        return <CircularProgress />

    if(!sportEvents || !sportEvents.length)
        return <Typography>Aucune rencontre ce jour</Typography>

console.log("nouveau sportEvents", sportEvents)

console.log("Selected ", sport)

    return <Box>
        <CalendarNavigation liveDates={liveDates} activeDate={date} setActiveDate={navigateToNewDate} />
        <Box sx={{ minWidth: '100%', display : 'flex', flexDirection : 'column', alignItems : 'center', justifyContent : 'center', pt : 3, pb : 1 }}>
            <Typography sx={{fontSize : '1.6em', fontWeight : 'bold'}}>{live.name}</Typography>
            {/*<Button onClick={navigateToCustomArticle} sx={{color : 'blue'}}>Accédez à notre direct du jour</Button>*/}
            <Filter sportsList={live.getSportsList()} selectedSport={sport} setSelectedSport={setSport}/>
        </Box>
        {sportEvents && <SportEventList events={sportEvents.sort((a, b) => new Date(a.date) - new Date(b.date))}
        selectedSport={sport}
        ></SportEventList>}
    </Box>
};

export default CalendarResolver